import React, { memo, useMemo } from "react";

// components
import { PaymentAlert } from "@payment-ui/components/payment-alert";

// constants
import { UPI_PAYMENT_ALERT_V4 } from "@payment-ui/constants/Upi";

// utils
import { format, isEmpty } from "@swiggy-private/js-utils";
import { PaymentAlertActionProps } from "@swiggy-private/payment-types";

interface CancelAlertInterface {
    paymentAmount: string;
    itemCount?: string;
    showCancelModal: boolean;
    onCancelTransaction: VoidFunction;
    onSecondaryActionClick: VoidFunction;
}

function CancelAlert({
    onCancelTransaction,
    onSecondaryActionClick,
    paymentAmount,
    itemCount,
    showCancelModal,
}: CancelAlertInterface) {
    const primaryActionInfo: PaymentAlertActionProps = useMemo(
        () => ({
            text: UPI_PAYMENT_ALERT_V4.PRIMARY_ACTION_NAME,
            onClick: onCancelTransaction,
        }),
        [onCancelTransaction],
    );

    const secondaryActionInfo: PaymentAlertActionProps = useMemo(
        () => ({
            text: UPI_PAYMENT_ALERT_V4.SECONDARY_ACTION_NAME,
            onClick: onSecondaryActionClick,
        }),
        [onSecondaryActionClick],
    );

    const subInfo = useMemo(() => {
        if (isEmpty(itemCount)) {
            return "";
        }
        return format(UPI_PAYMENT_ALERT_V4.SUB_INFO, String(itemCount));
    }, [itemCount]);

    if (!showCancelModal) {
        return null;
    }

    return (
        <PaymentAlert
            hideOnOverlayClick={false}
            hideIcon={true}
            title={UPI_PAYMENT_ALERT_V4.TITLE}
            message={UPI_PAYMENT_ALERT_V4.MESSAGE}
            primaryAction={primaryActionInfo}
            secondaryAction={secondaryActionInfo}
            info={format(UPI_PAYMENT_ALERT_V4.INFO, paymentAmount)}
            subInfo={subInfo}
            onClose={onSecondaryActionClick}
        />
    );
}

export default memo(CancelAlert);
